import React from "react";
import { pdf } from "@react-pdf/renderer";
import ProposalDocument from "../components/ProposalDocument";

export function buildDocProps(p) {
  const event = {
    eventTitle: p.eventTitle,
    membershipSize: p.membershipSize,
    electionType: p.electionType,
    startDate: p.startDate,
    endDate: p.endDate,
    voterTurnout: p.voterTurnout,
    location: p.location,
  };
  const estimatedVoters = Math.round(
    (Number(p.membershipSize) * (Number(p.voterTurnout) || 0)) / 100
  );
  const taxRate = p.subtotal > 0 ? p.tax / p.subtotal : 0;
  const estimate = {
    items: p.items || [],
    fixedSubtotal: p.fixedSubtotal,
    variableSubtotal: p.variableSubtotal,
    subtotal: p.subtotal,
    tax: p.tax,
    total: p.total,
    estimatedVoters,
    taxRate,
  };
  return { event, estimate, lead: p.lead || {} };
}

export async function buildBlob(p) {
  const { event, estimate, lead } = buildDocProps(p);
  return pdf(<ProposalDocument event={event} estimate={estimate} lead={lead} />).toBlob();
}

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1] || "");
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" });
  } catch (e) {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-CA", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (e) {
    return iso;
  }
};
